import React, { useState, useEffect } from 'react';
import SideMenuBar from '../../components/sideMenuBar';
import { useNavigate } from 'react-router-dom';
import { ACTIONS, KEYS, URLS } from '../../_config';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import Icon from '../../components/icons';
import Filter from '../../components/filter';
import { useStoreApi } from '../../store/api/hooks/storeApiHook';
import toast from 'react-hot-toast';
import Spinner from '../../components/iconSvgs/spinner';
import { allowOnlyNumbers } from '../../_common/functions';
import { ActivetabProps } from '../../_config/interfaces/interfaces';

const StoreInformation: React.FC<ActivetabProps> = ({ activeTab }) => {
    const [isDivVisible, setIsDivVisible] = useState(false);
    const [isOnSubmitLoading, setOnSubmitLoading] = React.useState<boolean>(false);
    const [storeData, setStoreData] = useState<any>(null);
    const [filterValue, setFilterValue] = useState<any>({});

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const storeAPI: any = useStoreApi();

    const { register, formState: { errors }, handleSubmit, setValue } = useForm<any>();
    
    useEffect(() => {
        getStores();
    }, []);

    const getStores = () => {
        storeAPI.getStore({}, (msg: any, resp: any) => {
            if (resp?.data) {
                dispatch({
                    type: ACTIONS.STORE.GET_STORE,
                    payload: resp.data,
                });
                setStoreData(resp.data);
                setValue("storeName", resp.data.name);
                setValue("storeBrnLimit", resp.data.branch_limit ? resp.data.branch_limit : 0);
            }
        }, (error: any, resp: any) => {
            console.log('error =>', error);
        })
    }

    const handleApplyFilter = (filterData: any) => {
        setFilterValue(filterData);
    };

    const handleClearFilter = () => {
        setFilterValue(null);
    };

    const onSubmit = (data: any) => {
        setOnSubmitLoading(true);
        const param = {
            new_name: data.storeName,
            branch_limit: data.storeBrnLimit,
        }

        try {
            setTimeout(() => {
                storeAPI.updateStoreInfo(param, (msg: any, resp: any) => {
                    if (resp?.code === 201 || resp?.code === 200) {
                        toast.success(resp?.message);
                        dispatch({
                            type: ACTIONS.STORE.GET_STORE,
                            payload: resp.data,
                        });
                    } else {
                        toast.error(resp?.message);
                    }
                }, (error: any, resp: any) => {
                    console.log('error =>', error, resp);
                    if (resp?.detail?.code === 400) {
                    } else {
                        toast.error("Something went wrong");
                    }
                });
                setOnSubmitLoading(false);
            }, 5000)
        } catch (e) {
            // console.log('error =>', e);
            setOnSubmitLoading(false);
        }
    };


    return (
        <>
            <div className="mt-6">
                <div className="flex justify-between items-center mb-4">
                    {isOnSubmitLoading && (
                        <div className="absolute inset-0 bg-gray-700 bg-opacity-50 flex justify-center items-center z-50">
                            <Spinner className="self-center z-50" />
                        </div>
                    )}
                    <h2 className="text-gray-500 text-xl font-semibold">Store Information</h2>
                    
                </div>

                <form className="mt-4" onSubmit={handleSubmit(onSubmit)}>
                    <div className="mb-4 relative">
                        <input type="text" {...register("storeName", { required: true })}
                            placeholder="Store Name" autoComplete="username"
                            className={`block-lg w-full rounded-sm bg-white px-3 py-1.5 pr-10 text-sm text-gray-500 outline outline-1 -outline-offset-1 ${errors.storeName ? 'outline-red-500 outline-2' : 'outline-gray-300'} placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm`}
                        />
                        <Icon name="store" size={20} className="absolute right-3 top-[25px] transform -translate-y-1/2 text-gray-400" />
                    </div>
                    <div className="mb-4 relative">
                        <input type="text" {...register("storeBrnLimit", { required: true })} onKeyDown={allowOnlyNumbers}
                            placeholder="Store Branch limit" className={`block-lg w-full rounded-sm bg-white px-3 py-1.5 pr-10 text-sm text-gray-500 outline outline-1 -outline-offset-1 ${errors.storeName ? 'outline-red-500 outline-2' : 'outline-gray-300'} placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm`}
                        />
                        
                    </div>

                    <div className="flex mb-3">
                        <button
                            type="submit"
                            className="flex w-32 justify-center rounded-md bg-blue-500 p-3 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500"
                        >
                            Update
                        </button>
                        
                    </div>
                </form>

            </div>
        </>
    );
}

export default StoreInformation;